import React from 'react'
import "../CSS/imagebrand.css";
function Imagebrand() {
    return (
        <div className="imagebrand">
            <div className="imagebrandbet">
                <div className="imageb">
                    <div className="imageheader">
                        Plant Based
                    </div>
                    <img src="https://media.discordapp.net/attachments/445928139021877259/1180937716024750220/Component_6.png?ex=657f3cf4&is=656cc7f4&hm=20d8fe458967e30e5ffd866b4911ca7f8ca203be90359afd27fcaab7985d2053&=&format=webp&quality=lossless" alt='อาหารจากพืช' />
                    </div>
                <div className="imageb">
                <div className="imageheader">
                        Ready To Eat
                    </div><img src="https://media.discordapp.net/attachments/445928139021877259/1180937715697590272/Component_7.png?ex=657f3cf4&is=656cc7f4&hm=f41e8ca7624c3cef8097a1e0cb6e0f71484571e1fcced1af4590e95e19aa8330&=&format=webp&quality=lossless" alt='delicatessen' /></div>
            </div>
        </div>
    )
}

export default Imagebrand